import { render, staticRenderFns } from "./SampleTypeSort.vue?vue&type=template&id=35616d02"
import script from "./SampleTypeSort.vue?vue&type=script&lang=js"
export * from "./SampleTypeSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports